import React,{useState,useEffect} from 'react';
import {LockClosedIcon,XIcon} from '@heroicons/react/outline';
import {enqueueSnackbar} from 'notistack';
import submitFormUtil from '../../utils/submit-form-util';
import locales from '../../locales/locales';
const ResetPassword=({email,code,onExit,globalSettings})=>{
  const [password,setPassword]=useState('');
  const [confirmPassword,setConfirmPassword]=useState('');
  const [passwordError,setPasswordError]=useState(null);
  const [confirmPasswordError,setConfirmPasswordError]=useState(null);
  const [isLoading,setIsLoading]=useState(false);
  useEffect(()=>{
    if(passwordError){
      setPasswordError(null);
    }
  },[password]);
  useEffect(()=>{
    if(confirmPasswordError){
      setConfirmPasswordError(null);
    }
  },[confirmPassword]);
  useEffect(()=>{
    if(confirmPassword&&confirmPassword!==password){
      setConfirmPasswordError(locales.resetPasswordMismatch);
    }
  },[password,confirmPassword]);
  const handleSubmit=async(e)=>{
    e.preventDefault();
    if(isLoading||confirmPassword!=password){
      return;
    }
    setIsLoading(true);
    const res=await submitFormUtil('/reset-password',{
      'new_password':[password,setPasswordError],
      'email':[email,()=>{}],
      'code':[code,()=>{}],
    },{
      'no_such_email':null,
      'code_invalid':(()=>{onExit(false);}),
    });
    setIsLoading(false);
    if(res){
      enqueueSnackbar(
        locales.resetPasswordSuccess[globalSettings.lang]
      ,{variant:'success'});
      onExit(true);
    }
  };
  return (
    <div className='fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50'>
      <form
        onSubmit={handleSubmit}
        className='bg-white rounded-xl shadow-lg max-w-md w-full mx-4 p-6 relative'
      >
        <div className='flex justify-between items-center mb-6'>
          <h2 className='text-2xl font-bold text-gray-900'>
            {locales.resetPasswordTitle[globalSettings.lang]}
          </h2>
          <button 
            type='button'
            onClick={()=>{onExit(true);}}
            className='text-gray-500 hover:text-gray-700'
          >
            <XIcon className='h-5 w-5' />
          </button>
        </div>
        <div className='mb-6'>
          <p className='text-gray-600 mb-4'>
            {locales.resetPasswordPrompt[globalSettings.lang]}
          </p>
          <div className='mb-4'>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              {locales.resetPasswordNewLabel[globalSettings.lang]}
            </label>
            <div className='relative'>
              <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                <LockClosedIcon className='h-5 w-5 text-gray-400' />
              </div>
              <input
                type='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={locales.resetPasswordNewPlaceholder[globalSettings.lang]}
                className={`w-full pl-10 pr-3 py-2 border ${passwordError ? 'border-red-300' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600`}
              />
            </div>
            {passwordError&&<p className='mt-1 text-sm text-red-600'>{passwordError[globalSettings.lang]}</p>}
          </div>
          <div className='mb-4'>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              {locales.resetPasswordConfirmLabel[globalSettings.lang]}
            </label>
            <div className='relative'>
              <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                <LockClosedIcon className='h-5 w-5 text-gray-400' />
              </div>
              <input
                type='password'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder={locales.resetPasswordConfirmPlaceholder[globalSettings.lang]}
                className={`w-full pl-10 pr-3 py-2 border ${confirmPasswordError ? 'border-red-300' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600`}
              />
            </div>
            {confirmPasswordError&&<p className='mt-1 text-sm text-red-600'>{confirmPasswordError[globalSettings.lang]}</p>}
          </div>
        </div>
        <div className='flex space-x-4'>
          <button
            type='button'
            onClick={()=>{onExit(true);}}
            className='flex-1 border border-gray-300 text-gray-700 px-4 py-2 rounded-lg text-lg font-medium hover:bg-gray-50 transition'
          >
            {locales.resetPasswordCancel[globalSettings.lang]}
          </button>
          <button
            type='submit'
            disabled={isLoading}
            className={`flex-1 bg-purple-800 hover:bg-purple-600 text-white px-4 py-2 rounded-lg text-lg font-medium transition ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
          >
            {
              isLoading?
              locales.resetPasswordProcessing[globalSettings.lang]:
              locales.resetPasswordConfirm[globalSettings.lang]
            }
          </button>
        </div>
      </form>
    </div>
  );
};
export default ResetPassword;

